import { ReactElement, SVGProps, isValidElement } from 'react';

import { IconColor, IconDisabledColor, IconHoveredColor } from '@hh.ru/magritte-ui-icon/colors';

export interface IconProps extends SVGProps<SVGSVGElement> {
    /* Указывает начальный цвет иконки */
    initial?: IconColor;
    /* Указывает есть ли поддержка accessibility API, если aria-label не указан
     * считаем что нет поддержки. Если указан, то есть возможность для отключения.
     * */
    'aria-hidden'?: boolean;
}

export interface IconDynamicProps extends IconProps {
    /* Указывает цвет иконки, в случае если иконка динамическая
     * (hover, focus etc. states)
     * */
    highlighted: IconHoveredColor;
    /* Указывает цвет иконки, в случае если иконка динамическая
     * и задизейблена
     * */
    disabled: IconDisabledColor;
}

type MakeNever<T> = {
    [key in keyof T]?: never;
};

type IconPropsUnion = (IconProps & MakeNever<Omit<IconDynamicProps, keyof IconProps>>) | IconDynamicProps;
export const isIconComponent = (
    component: ReactElement
): component is ReactElement<IconPropsUnion, IconWrapperComponent> => {
    return isValidElement(component) && typeof component.type !== 'string' && 'isIcon' in component?.type;
};

export interface IconWrapperComponent<T = null> {
    (props: T extends null ? IconProps | IconDynamicProps : (IconProps | IconDynamicProps) & T): ReactElement;
    displayName?: string;
    isIcon?: boolean;
    _size?: number;
}

export interface IconWrapperComponentSize16<T = null> extends IconWrapperComponent<T> {
    _size: 16;
}
export interface IconWrapperComponentSize24<T = null> extends IconWrapperComponent<T> {
    _size: 24;
}
export interface IconWrapperComponentSize32<T = null> extends IconWrapperComponent<T> {
    _size: 32;
}
